import dJSON from 'dirty-json';

const moduleSelector = '.cta-3';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.cta-3__content-section__details').insertAdjacentHTML('beforeend', /* html */ `
          <a href="${item.link_url}" class="item">
            <div class="icon-wrapper">
              <img src="${item.icon}" alt="">
            </div>
            <div class="content-wrapper">
              <h3 class="title">${item.title || ''}</h3>
              <p class="link">${item.link_text || ''}</p>
            </div>
          </a>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
